import React from "react";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import authImg from "assets/img/auth/auth.png"; // Asegúrate de que la ruta y el nombre del archivo sean correctos
import Footer from "components/footer/FooterAuthDefault";

// Definir tipos para los props de InputField
interface InputFieldProps {
  variant: string;
  extra?: string;
  label: string;
  placeholder: string;
  id: string;
  type: string;
}

// Componente FixedPlugin
function FixedPlugin() {
  return (
    <div className="fixed bottom-0 right-0 m-4">
      <p className="text-sm text-gray-500">Plugin Fijo</p>
    </div>
  );
}

// Componente FooterAuthDefault
function FooterAuthDefault() {
  return (
    <footer className="mt-12 text-center text-gray-600 dark:text-gray-400">
      © {new Date().getFullYear()} Tu Empresa. Todos los derechos reservados.
    </footer>
  );
}

// Componente InputField
function InputField({ variant, extra = "", label, placeholder, id, type }: InputFieldProps) {
  return (
    <div className={`mb-4 ${extra}`}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <input
        type={type}
        id={id}
        className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm ${variant}`}
        placeholder={placeholder}
      />
    </div>
  );
}

// Componente Checkbox
function Checkbox() {
  return (
    <input
      type="checkbox"
      className="h-4 w-4 rounded border-gray-600 text-brand-600 focus:ring-brand-500"
    />
  );
}

// Componente SignIn
function SignIn() {
  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
        Bienvenido de nuevo!
        </h4>
     
        <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800">
          <div className="rounded-full text-xl">
            <FcGoogle />
          </div>
          <a href="/admin"  >
          <h5 className="text-sm font-medium text-navy-700 dark:text-white">
          Iniciar sesión con Google
          </h5> </a>
        </div>
        <div className="mb-6 flex items-center gap-3">
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
          <p className="text-base text-gray-600 dark:text-white">o</p>
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
        </div>
        <p className="mb-9 ml-1 text-base text-center text-gray-900">
        Accede a tu cuenta para aprovechar al máximo todas nuestras herramientas empresariales.
        </p>
        <InputField
          variant="auth"
          extra="mb-3"
          label="Correo Electronico*"
          placeholder="mail@gmail.com"
          id="email"
          type="text"
        />
        <InputField
          variant="auth"
          extra="mb-3"
          label="Contraseña*"
          placeholder="Min. 8 caracteres"
          id="password"
          type="password"
        />
        <div className="mb-4 flex items-center justify-between px-2">
          <div className="flex items-center">
            <Checkbox />
            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
            Mantente conectado
            </p>
          </div>
          <a
            className="text-sm font-medium text-center text-brand-500 hover:text-brand-600 dark:text-white"
            href="#"
          >
           ¿Olvidaste tu contraseña? Recupérala aquí.
          </a>
        </div>
        <a href="/admin"  >
        <button className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
          Iniciar sesion
        </button></a>
        <div className="mt-6">
          <span className="text-center font-medium text-navy-700 dark:text-gray-600">
          ¿Aún no eres miembro premium? Eleva tu gestión empresarial al siguiente nivel.
          </span>
      
          <a href="/admin"  >
  <button className="mb-3 linear mt-6 w-full rounded-xl bg-brand-500 py-[10px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
    ¡Compra una membresía!
  </button>
</a>

        </div>
      </div>
    </div>
  );
}

// Componente Auth principal
export default function Auth() {
  document.documentElement.dir = "ltr";

  return (
    <div className="relative float-right h-full min-h-screen w-full !bg-white dark:!bg-navy-900">
      <FixedPlugin />
      <main className="mx-auto min-h-screen">
        <div className="relative flex">
          <div className="mx-auto flex min-h-full w-full flex-col justify-start pt-12 md:max-w-[75%] lg:h-screen lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:h-[100vh] xl:max-w-[1383px] xl:px-0 xl:pl-[70px]">
            <div className="mb-auto flex flex-col pl-5 pr-5 md:pr-0 md:pl-12 lg:max-w-[48%] lg:pl-0 xl:max-w-full">
              <Link to="/admin" className="mt-0 w-max lg:pt-10">
                <div className="mx-auto flex h-fit w-fit items-center hover:cursor-pointer">
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.70994 2.11997L2.82994 5.99997L6.70994 9.87997C7.09994 10.27 7.09994 10.9 6.70994 11.29C6.31994 11.68 5.68994 11.68 5.29994 11.29L0.709941 6.69997C0.319941 6.30997 0.319941 5.67997 0.709941 5.28997L5.29994 0.699971C5.68994 0.309971 6.31994 0.309971 6.70994 0.699971C7.08994 1.08997 7.09994 1.72997 6.70994 2.11997V2.11997Z"
                      fill="#A3AED0"
                    />
                  </svg>
                  <p className="ml-3 text-sm text-gray-600">
                    Volver a Gestion Empresarial
                  </p>
                </div>
              </Link>
              <Routes>
                <Route path="/sign-in" element={<SignIn />} />
                <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
              </Routes>
              <div className="absolute right-0 hidden h-full min-h-screen md:block lg:w-[49vw] 2xl:w-[44vw]">
                <div
                  className="absolute flex h-full w-full items-end justify-center bg-cover bg-center"
                  style={{ backgroundImage: `url(${authImg})` }} // Asegúrate de que authImg esté definido correctamente
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </main>
    </div>
  );
}
